import React, { useState } from "react";
import { HR_PERMISSIONS, hasHrPermission } from "../../constants/hrPermissions";
import MyRoster from "./time/MyRoster";
import RosterBoard from "./time/RosterBoard";
import SwapsTab from "./time/SwapsTab";
import { PageHeader, Tabs } from "./hrComponents";
import { useHr } from "./HrGate";
import { pageStyle } from "./hrUi";

// Roster: my shifts and swap requests, and the board for the people the caller manages (HR and attendance admins can edit it).
export default function Roster() {
  const { access } = useHr();
  const canEdit = hasHrPermission(access, HR_PERMISSIONS.HR_ADMIN, HR_PERMISSIONS.ATTENDANCE_ADMIN);
  const isEmployee = !!access.is_employee;
  const [tab, setTab] = useState(isEmployee ? "mine" : "board");
  const tabs = [
    ...(isEmployee ? [{ key: "mine", label: "My roster" }, { key: "swaps", label: "Swaps" }] : []),
    { key: "board", label: "Roster board" },
  ];
  return (
    <div style={pageStyle}>
      <PageHeader title="Roster" subtitle="Shifts, days off and swaps" />
      <Tabs tabs={tabs} active={tab} onChange={setTab} />
      {tab === "mine" ? <MyRoster /> : null}
      {tab === "swaps" ? <SwapsTab myName={access.employee?.full_name} /> : null}
      {tab === "board" ? <RosterBoard canEdit={canEdit} /> : null}
    </div>
  );
}
